import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import LocationsPageRoute from './LocationsPageRoute';

const basePath = '/v2/locations';

// v5's <Switch> nested inside <MainLayout> becomes a layout route: the parent carries the layout as
// `element` and the former Switch children become nested routes. `index` replaces `exact path` for
// the child that matches the parent path exactly, and `path="*"` replaces the bare catch-all Route.
export default (
  <Route
    path={basePath}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<LocationsPageRoute />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
